import axios from 'axios';

const isProd = process.env.NODE_ENV === 'production';
const API_BASE_URL = isProd 
    ? 'https://api-delf.king.sv/api'
    : 'http://localhost:5000/api';

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json'
    }
});

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 504) {
            return {
                data: {
                    status: 'queued',
                    message: 'Request is being processed in the background'
                }
            };
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;